export default __webpack_public_path__ + "static/cabins-overview-2-24666c95ef6c3d6e16f9a274f673dac0.jpg";